<button
  [type]="type()"
  [disabled]="disabled() || loading()"
  [class]="buttonClasses() + ' ' + (styleClass() || '')"
  [attr.aria-label]="nativeAria().label"
  [attr.aria-labelledby]="nativeAria().labelledBy"
  [attr.aria-haspopup]="nativeAria().hasPopup"
  [attr.aria-describedby]="nativeAria().describedBy"
  [attr.aria-expanded]="nativeAria().expanded"
  [attr.aria-pressed]="nativeAria().pressed"
  [attr.aria-controls]="nativeAria().controls"
  [attr.aria-busy]="loading()"
  [tabIndex]="disabled() ? -1 : tabIndex()"
  (click)="handleClick($event)">

  @if (loading()) {
    <svg class="h-4 w-4 animate-spin" [class.mr-2]="label()" viewBox="0 0 24 24" fill="none">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
      </path>
    </svg>
  }

  <!-- GAP-FE-PRIME-P4 r11 (Codex) · suppress the static icon while
       loading() is true so the spinner has the icon slot to itself.
       Callers can bind `[loading]="busy()"` + `icon="X"` and trust
       the button to render only one glyph at a time. -->
  <!-- Margin is CONDITIONAL on a label: an icon-only button (icon input, no
       label) gets NO margin so the lone glyph centres in the justify-center
       flex; icon+label keeps exactly 0.5rem. Buttons that PROJECT their own
       <ui-icon> via <ng-content> manage their own margins and are unaffected. -->
  @if (icon() && iconPos() === 'left' && !loading()) {
    <ui-icon [name]="icon()!" [size]="iconSize()" [class.mr-2]="label()"></ui-icon>
  }

  @if (label()) {
    {{ label() }}
  }

  <ng-content></ng-content>

  @if (icon() && iconPos() === 'right' && !loading()) {
    <ui-icon [name]="icon()!" [size]="iconSize()" [class.ml-2]="label()"></ui-icon>
  }
</button>
